// @ts-nocheck
import React from 'react';

import './styles.scss';

type Props = {
  icon?: string;
  label: string;
  showTitle?: boolean;
  value: string;
};

function Detail({ icon, label, showTitle, value }: Props) {
  const className = icon ? 'detail__key detail__key--icon' : 'detail__key';

  return (
    <>
      <div className={className}>
        {icon && <i className={`${icon} detail__keyIcon`} />}
        {label}
      </div>
      <div className="detail__value" title={showTitle ? value : ''}>
        {value}
      </div>
    </>
  );
}

export default Detail;
